import { Action } from 'redux';
import { LoginResponse, VerifiedOTPResponse, ChangePasswordFormPayload, SendOTPFormPayload } from '../../models/authentication';
import { APIError } from '../../helpers/types';

export enum AuthActionTypes {

  ACTION_AUTH_SIGNUP_INIT = 'AUTH_SIGNUP_INIT',
  ACTION_AUTH_SIGNUP_SUBMIT = 'AUTH_SIGNUP_SUBMIT',
  ACTION_AUTH_SIGNUP_SUBMIT_SUCCESS = 'AUTH_SIGNUP_SUBMIT_SUCCESS',
  ACTION_AUTH_SIGNUP_SUBMIT_ERROR = 'AUTH_SIGNUP_SUBMIT_ERROR',

  ACTION_AUTH_LOGIN_SUBMIT = 'AUTH_LOGIN_SUBMIT',
  ACTION_AUTH_LOGIN_SUBMIT_SUCCESS = 'AUTH_LOGIN_SUBMIT_SUCCESS',
  ACTION_AUTH_LOGIN_SUBMIT_ERROR = 'AUTH_LOGIN_SUBMIT_ERROR',

  ACTION_AUTH_LOGOUT_SUBMIT = 'AUTH_LOGOUT_SUBMIT',
  ACTION_AUTH_LOGOUT_SUBMIT_SUCCESS = 'AUTH_LOGOUT_SUBMIT_SUCCESS',
  ACTION_AUTH_LOGOUT_SUBMIT_ERROR = 'AUTH_LOGOUT_SUBMIT_ERROR',

  ACTION_AUTH_FORGOTPASSWORD_SUBMIT = 'AUTH_FORGOTPASSWORD_SUBMIT',
  ACTION_AUTH_FORGOTPASSWORD_SUBMIT_SUCCESS = 'AUTH_FORGOTPASSWORD_SUBMIT_SUCCESS',
  ACTION_AUTH_FORGOTPASSWORD_SUBMIT_ERROR = 'AUTH_FORGOTPASSWORD_SUBMIT_ERROR',

  ACTION_AUTH_SENDOTP_SUBMIT = 'AUTH_SENDOTP_SUBMIT',
  ACTION_AUTH_SENDOTP_SUBMIT_SUCCESS = 'AUTH_SENDOTP_SUBMIT_SUCCESS',
  ACTION_AUTH_SENDOTP_SUBMIT_ERROR = 'AUTH_SENDOTP_SUBMIT_ERROR',

  ACTION_AUTH_VERIFYOTP_SUBMIT = 'AUTH_VERIFYOTP_SUBMIT',
  ACTION_AUTH_VERIFYOTP_SUBMIT_SUCCESS = 'AUTH_VERIFYOTP_SUBMIT_SUCCESS',
  ACTION_AUTH_VERIFYOTP_SUBMIT_ERROR = 'AUTH_VERIFYOTP_SUBMIT_ERROR',

  ACTION_AUTH_CHANGEPASSWORD_SUBMIT = 'AUTH_CHANGEPASSWORD_SUBMIT',
  ACTION_AUTH_CHANGEPASSWORD_SUBMIT_SUCCESS = 'AUTH_CHANGEPASSWORD_SUBMIT_SUCCESS',
  ACTION_AUTH_CHANGEPASSWORD_SUBMIT_ERROR = 'AUTH_CHANGEPASSWORD_SUBMIT_ERROR',

}

// SIGNUP
export interface ActionAuthSignupInit extends Action {
  type: AuthActionTypes.ACTION_AUTH_SIGNUP_INIT;
}
export interface ActionAuthSignupSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT;
}
export interface ActionAuthSignupSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_SUCCESS;
}
export interface ActionAuthSignupSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_ERROR;
  error: APIError;
}

// LOGIN
export interface ActionAuthLoginSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT;
}
export interface ActionAuthLoginSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_SUCCESS;
  payload: LoginResponse;
}
export interface ActionAuthLoginSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_ERROR;
  error: APIError;
}

// LOGOUT
export interface ActionAuthLogoutSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT;
}
export interface ActionAuthLogoutSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_SUCCESS;
}
export interface ActionAuthLogoutSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_ERROR;
  error: APIError;
}

// FORGOT PASSWORD
export interface ActionAuthForgotPasswordSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT;
}
export interface ActionAuthForgotPasswordSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_SUCCESS;
}
export interface ActionAuthForgotPasswordSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_ERROR;
  error: APIError;
}

// SEND OTP
export interface ActionAuthSendOTPSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT;
  payload: SendOTPFormPayload;
}
export interface ActionAuthSendOTPSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_SUCCESS;
}
export interface ActionAuthSendOTPSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_ERROR;
  error: APIError;
}

// VERIFY OTP
export interface ActionAuthVerifyOTPSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT;
}
export interface ActionAuthVerifyOTPSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_SUCCESS;
  payload: VerifiedOTPResponse;
}
export interface ActionAuthVerifyOTPSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_ERROR;
  error: APIError;
}

// CHANGE PASSWORD
export interface ActionAuthChangePasswordSubmit extends Action {
  type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT;
  payload: ChangePasswordFormPayload;
}
export interface ActionAuthChangePasswordSubmitSuccess extends Action {
  type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_SUCCESS;
}
export interface ActionAuthChangePasswordSubmitError extends Action {
  type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_ERROR;
  error: APIError;
}

export type AuthActions =
  | ActionAuthSignupInit
  | ActionAuthSignupSubmit
  | ActionAuthSignupSubmitSuccess
  | ActionAuthSignupSubmitError
  | ActionAuthLoginSubmit
  | ActionAuthLoginSubmitSuccess
  | ActionAuthLoginSubmitError
  | ActionAuthLogoutSubmit
  | ActionAuthLogoutSubmitSuccess
  | ActionAuthLogoutSubmitError
  | ActionAuthForgotPasswordSubmit
  | ActionAuthForgotPasswordSubmitSuccess
  | ActionAuthForgotPasswordSubmitError
  | ActionAuthSendOTPSubmit
  | ActionAuthSendOTPSubmitSuccess
  | ActionAuthSendOTPSubmitError
  | ActionAuthVerifyOTPSubmit
  | ActionAuthVerifyOTPSubmitSuccess
  | ActionAuthVerifyOTPSubmitError
  | ActionAuthChangePasswordSubmit
  | ActionAuthChangePasswordSubmitSuccess
  | ActionAuthChangePasswordSubmitError;